import { useEffect, useMemo, useState } from "react";
import usePWAStatus from "./hooks/usePWAStatus";
import AboutInstall from "./components/AboutInstall";
import CreateAccount from "./app-components/CreateAccount";
import Home from "./app-components/Home";

function DebugBox({ data }) {
    return (
        <div style={{
            position: "fixed", right: 8, bottom: 8, zIndex: 99999,
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
            fontSize: 11, lineHeight: 1.35,
            padding: "8px 10px", borderRadius: 8,
            background: "rgba(0,0,0,.7)", color: "#9EF99E", border: "1px solid rgba(255,255,255,.12)",
            maxWidth: "90vw", whiteSpace: "pre-wrap"
        }}>
            {Object.entries(data).map(([k, v]) => (
                <div key={k}><b>{k}:</b> {String(v)}</div>
            ))}
        </div>
    );
}

export default function App() {
    const { isStandalone } = usePWAStatus();
    const [boot, setBoot] = useState(true);
    const [user, setUser] = useState(null);

    const usp = useMemo(() => {
        try { return new URLSearchParams(window.location.search); } catch { return new URLSearchParams(); }
    }, []);

    useEffect(() => {
        if (usp.has("hardreset")) {
            (async () => {
                try { localStorage.clear(); } catch {}
                try {
                    if ("caches" in window) {
                        const keys = await caches.keys();
                        await Promise.all(keys.map(k => caches.delete(k)));
                    }
                } catch {}
                try {
                    if (navigator.serviceWorker && navigator.serviceWorker.getRegistrations) {
                        const regs = await navigator.serviceWorker.getRegistrations();
                        await Promise.all(regs.map(r => r.unregister()));
                    }
                } catch {}
                const base = window.location.origin + window.location.pathname;
                window.location.replace(base);
            })();
        }
    }, [usp]);

    const devForce = useMemo(() => {
        try {
            if (usp.has("about")) return "about";
            if (usp.has("create")) return "create";
            if (usp.has("home") || usp.has("map")) return "home";
            return localStorage.getItem("dk_force_route") || null;
        } catch {
            return null;
        }
    }, [usp]);

    useEffect(() => {
        const t = setTimeout(() => setBoot(false), 400);
        try {
            const raw = localStorage.getItem("dk_user");
            if (raw) setUser(JSON.parse(raw));
        } catch {}
        return () => clearTimeout(t);
    }, []);

    const route = devForce
        ? devForce
        : !isStandalone
            ? "about"
            : boot
                ? "boot"
                : !user
                    ? "create"
                    : "home";

    const showDiag = useMemo(() => {
        try {
            if (usp.has("diag")) return true;
            return localStorage.getItem("dk_diag") === "1";
        } catch { return false; }
    }, [usp]);

    const dbg = {
        route,
        isStandalone,
        boot,
        hasUser: !!user,
        notifPerm: (typeof Notification !== "undefined" ? Notification.permission : "n/a"),
        ua: navigator.userAgent
    };

    return (
        <>
            {route === "about" && <AboutInstall />}
            {route === "boot" && <div style={{ minHeight: "100dvh", background: "#0b122a" }} />}
            {route === "create" && (
                <CreateAccount
                    onCreated={(u) => {
                        try { localStorage.setItem("dk_user", JSON.stringify(u)); } catch {}
                        setUser(u);
                    }}
                />
            )}
            {route === "home" && <Home user={user} />}
            {showDiag && <DebugBox data={dbg} />}
        </>
    );
}
